import { privateApi } from '@/config';

export interface TrialDaysResponse {
  daysRemaining: number;
  trialEnabled: boolean;
  trialEndsAt: string | null;
  isInTrial: boolean;
}

/**
 * API service para obtener información sobre días de prueba
 */
export const trialApi = {
  /**
   * Obtiene los días de prueba restantes del tenant actual
   */
  getTrialDaysRemaining: async (): Promise<TrialDaysResponse> => {
    try {
      const response = await privateApi.get('/subscriptions/trial-days');
      // El ResponseTransformInterceptor envuelve la respuesta en { success, data, ... }
      const data = response.data?.data || response.data;
      return data;
    } catch (error: any) {
      throw error;
    }
  },
};



